import { render, staticRenderFns } from "./SecondObj.vue?vue&type=template&id=73556cd2&scoped=true"
import script from "./SecondObj.vue?vue&type=script&lang=js"
export * from "./SecondObj.vue?vue&type=script&lang=js"
import style0 from "./SecondObj.vue?vue&type=style&index=0&id=73556cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73556cd2",
  null
  
)

export default component.exports